import type { DecoBuildCtx } from "./define.ts";
import { shade, rand } from "../color.ts";

// A rounded low-poly tree: a tapered-capsule trunk + 2-3 overlapping foliage
// balls, varied per instance (rounded art style, plan 28 stage 4).
// Geometry only — spawn metadata (weight/mapColor/habitat/sway/…) lives in
// content/decos/tree.json; this build is registered in src/model/coded.ts.
const build: (ctx: DecoBuildCtx) => void = ({ bone, ball, seed }) => {
    const trunkColor = shade(0x6b4a2b, (rand(seed) - 0.5) * 0.2);
    const leafBase = shade(0x356b2f, (rand(seed + 1) - 0.5) * 0.3);
    const h = 2.6 + rand(seed + 2) * 1.4;

    // trunk — tapered capsule, wider at the base; the bottom cap sinks slightly
    // into grade (trees are planted), the top cap buries inside the canopy.
    bone(0, 0.1, 0, 0, h * 0.6, 0, 0.3, 0.18, trunkColor);

    // foliage — 2-3 overlapping balls, biggest at the base tapering up (keeps
    // the old per-layer shade() stepping + the same w*0.7 taper cadence).
    const layers = 2 + Math.floor(rand(seed + 3) * 2);
    let y = h * 0.6;
    let r = 1.2;
    for (let i = 0; i < layers; i++) {
      const jx = (rand(seed + i * 5) - 0.5) * r * 0.12;
      const jz = (rand(seed + i * 5 + 1) - 0.5) * r * 0.12;
      const depth = 0.98 + rand(seed + i * 5 + 2) * 0.12;
      ball(jx, y + r * 0.55, jz, r, shade(leafBase, i * 0.06), depth);
      y += r * 0.9;
      r *= 0.7;
    }
  };

export default build;
